module.exports = __webpack_public_path__ + "static/img/compress_file.aa288d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/compress_file.svg
// module id = KnUO
// module chunks = 46